import React from 'react';
import { Alert, alertClasses, AlertProps, styled } from '@mui/material';

interface RangeItemContainerProps extends AlertProps {
  selected?: boolean;
}

export const RangeItemContainer = styled(
  ({ selected, ...alertProps }: RangeItemContainerProps) => (
    <Alert variant="outlined" severity="success" icon={false} {...alertProps} />
  ),
  {
    shouldForwardProp: prop => !['selected'].includes(prop as any),
  }
)(({ selected = false, theme }) => ({
  [`&.${alertClasses.root}`]: {
    border: `1px solid ${theme.palette.success.light}`,
    cursor: 'pointer',
    backgroundColor: selected ? `rgba(227, 247, 201, 0.5)` : 'inherit',
    paddingRight: 20,

    [`.${alertClasses.action}`]: {
      display: 'none',
    },

    '&:hover': {
      backgroundColor: `rgba(227, 247, 201, 0.5)`,

      [`.${alertClasses.action}`]: {
        display: 'flex',
      },
    },
  },
}));
